import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    tagIcon: {
        width: 16,
        height: 16
    },
    link: {
        textDecoration: 'none',
        color: 'initial',
        cursor: 'pointer'
    }
});
